<template>
	
  <v-app>
    <v-main>
			<router-view />
    </v-main>
  </v-app>

</template>

<script>

import UrlCfg from "./config/url.js";

export default {
  name: 'App',

  components: {
	  
  },

  data: () => ({
    //
  }),
  created: function () {
    console.log('app created');
  }
  
};
</script>
